import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown";
import { CheckIcon } from "lucide-react";
import { useConfirm } from "@/context/confirm-context";
import { usePatchOrgMember } from "@/queries/organization-members";
import { useOrganizationRoles } from "@/queries/organization-roles";
import { OrganizationMember } from "@/types/organization-member";

interface ChangeMemberRoleProps {
  organizationMember: OrganizationMember;
}

const ChangeMemberRole = ({ organizationMember }: ChangeMemberRoleProps) => {
  const organizationRoles = useOrganizationRoles().data;
  const patchOrgMemberRole = usePatchOrgMember();
  const { confirm } = useConfirm();

  const handleClick = async (roleId: string) => {
    const selectedRoleId = parseInt(roleId, 10);
    if (organizationMember.organization_role.id === selectedRoleId) return;
    const isConfirmed = await confirm({
      message: `Are you sure you want to update the role of this member? This action will update the role of ${
        organizationMember.user.email
      } from ${
        organizationMember.organization_role.name
      } to ${organizationRoles?.find((el) => el.id === selectedRoleId)
        ?.name} in organization and all workspaces of the organization. This action cannot be undone.`,
    });
    if (isConfirmed)
      patchOrgMemberRole.mutate({
        organizationMemberId: organizationMember.id,
        organizationRoleId: selectedRoleId,
      });
  };

  return (
    <DropdownMenuGroup>
      <DropdownMenuLabel>Role</DropdownMenuLabel>
      {organizationRoles?.map((role) => (
        <DropdownMenuItem
          key={role.id}
          className="justify-between capitalize"
          onClick={() => handleClick(role.id.toString())}
        >
          {role.name}
          {organizationMember.organization_role.id === role.id && (
            <CheckIcon className="h-4 w-4" />
          )}
        </DropdownMenuItem>
      ))}
      <DropdownMenuSeparator />
    </DropdownMenuGroup>
  );
};

export default ChangeMemberRole;
